import {
  getCurrentTime,
  getDuration,
  IPlayer,
  isPlayerReady,
  setSeekPosition,
} from "../utils/shaka"
import { useCallback } from "react"
import debounce from "lodash.debounce"

export function useVideoPosition(player: IPlayer | null): [number, (value: number) => void] {
  // TODO: consider forking to get more responsive seek
  function handleSetVideoPosition(value: number) {
    setSeekPosition(player, (value / 100) * getDuration(player))
  }

  const debouncedOnChange = useCallback(debounce(handleSetVideoPosition, 50), [player])

  function handleChange(newVal: number) {
    if (!isPlayerReady(player)) {
      return
    }
    debouncedOnChange(newVal)
  }
  const videoPosition = isPlayerReady(player)
    ? (getCurrentTime(player) / getDuration(player)) * 100
    : 0
  return [videoPosition, handleChange]
}
